const selectors = {
  copyClipboard: '[data-copy-clipboard]',
  tooltip: 'data-tooltip',
};

const classes = {
  visible: 'is-visible',
};

const sections = {};

class CopyClipboard {
  constructor(section) {
    this.container = section.container;
    this.copyButtons = this.container.querySelectorAll(selectors.copyClipboard);

    if (this.copyButtons.length) {
      this.init();
    }
  }

  init() {
    this.copyButtons.forEach((el) => {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        const copyText = this.getAttribute('href');
        this.style.position = 'static';
        let inputElem = document.createElement('input');
        inputElem.type = 'text';
        this.appendChild(inputElem);
        const newInput = this.querySelector('input');
        newInput.value = copyText;
        newInput.select();
        newInput.setSelectionRange(0, 99999); /* For mobile devices */
        document.execCommand('copy');
        this.style.removeProperty('position');
        this.removeChild(newInput);

        if (this.hasAttribute(selectors.tooltip) && windowWidth > 749) {
          this.classList.add(classes.visible);
          this.dispatchEvent(new CustomEvent('tooltip:init', {bubbles: true}));

          setTimeout(() => {
            this.classList.remove(classes.visible);
            document.dispatchEvent(
              new CustomEvent('tooltip:close', {
                bubbles: false,
                detail: {
                  hideTransition: true,
                },
              })
            );
          }, 2000);
        }
      });
    });
  }
}

const copyClipboard = {
  onLoad() {
    sections[this.id] = new CopyClipboard(this);
  },
};

export default copyClipboard;
